(function () {
  if (window.SetupUrteil) return;

  var KEY = '3idee_auswahl';
  var merk = {};

  function auswahl() {
    try { return JSON.parse(localStorage.getItem(KEY) || 'null') || {}; } catch (e) { return {}; }
  }
  function proxy() { return (window.FinderClean && window.FinderClean.proxy) || '/apps/monitor-db'; }
  function abruf(url) {
    if (window.EngineStatus) return window.EngineStatus.hol(url);
    return fetch(url).then(function (r) { return r.json(); });
  }
  function daten(j) {
    if (!j || !j.ok || !j.data) throw new Error('engine');
    return j.data;
  }

  function monitor(ref) {
    return Promise.all([
      abruf(proxy() + '/monitors/' + encodeURIComponent(ref)).then(daten),
      abruf(proxy() + '/monitors/' + encodeURIComponent(ref) + '/compatibility').then(daten)
    ]).then(function (b) {
      var m = b[0] || {}, v = m.vesa, recs = (b[1] && b[1].recommendations) || [];
      var fall = 'ok', adapter = false;
      if (!v || (v.mount !== 'NO' && !(v.patterns && v.patterns.length))) fall = 'offen';
      else if (v.mount === 'NO') {
        adapter = recs.some(function (r) {
          return r.requirement === 'REQUIRED' && (r.products || []).some(function (p) { return p.in_shop !== false; });
        });
        if (!adapter) fall = 'sonder';
      }
      return { ref: String(ref), name: m.name || '', fall: fall, adapter: adapter };
    });
  }

  function hole() {
    var a = auswahl();
    var refs = (a.refs || []).map(String).filter(Boolean);
    if (!refs.length) return Promise.resolve(null);
    var schl = refs.join(',');
    if (merk[schl]) return merk[schl];
    var einzeln = [];
    refs.forEach(function (r) { if (einzeln.indexOf(r) < 0) einzeln.push(r); });
    var qs = refs.map(function (r) { return 'm=' + encodeURIComponent(r); }).join('&');
    merk[schl] = Promise.all([
      Promise.all(einzeln.map(monitor)),
      abruf(proxy() + '/combinations/compatible?' + qs).then(daten)
    ]).then(function (b) {
      var mons = b[0];
      return {
        refs: refs,
        monitore: mons,
        offen: mons.filter(function (m) { return m.fall === 'offen'; }),
        sonder: mons.filter(function (m) { return m.fall === 'sonder'; }),
        kombis: (b[1] && b[1].combinations) || []
      };
    }).catch(function () {
      delete merk[schl];
      return { refs: refs, ausfall: true };
    });
    return merk[schl];
  }

  function skuListe(skus) {
    return String(skus || '').split(',').map(function (s) { return s.trim().toLowerCase(); }).filter(Boolean);
  }

  function fuer(stand, skus) {
    if (!stand) return null;
    if (stand.ausfall) return { urteil: 'ausfall', requires: [] };
    if (stand.sonder.length) return { urteil: 'sonder', requires: [], monitore: stand.sonder };
    if (stand.offen.length) return { urteil: 'offen', requires: [], monitore: stand.offen };
    var eigen = skuListe(skus);
    var kombi = stand.kombis.filter(function (k) {
      var s = String((k.product && k.product.shopify_sku) || k.sku || '').toLowerCase();
      return s && eigen.indexOf(s) > -1;
    })[0];
    if (!kombi) return { urteil: 'nein', requires: [] };
    return { urteil: 'traegt', kombi: kombi,
             requires: (kombi.requires || []).filter(function (r) { return r && r.handle && r.in_shop !== false; }) };
  }

  function finderWeg(basis) {
    var u = basis || ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'pages/setup-finder';
    return u + (u.indexOf('?') > -1 ? '&' : '?') + 'finder=neu&setup=1';
  }

  window.SetupUrteil = { hole: hole, fuer: fuer, finderWeg: finderWeg };
  document.addEventListener('finder:auswahl', function () { merk = {}; });
  window.addEventListener('storage', function (e) { if (e.key === KEY) merk = {}; });
})();
